import React from 'react';
import { Link } from 'react-router-dom';

import ContactIcons from '../Contact/ContactIcons';

const { PUBLIC_URL } = process.env; // set automatically from package.json:homepage

const SideBar = () => (
  <section id="sidebar">
    <section id="intro">
      <Link to="/" className="logo">
        <img src={`${PUBLIC_URL}/images/pic.jpg`} alt="" />
      </Link>
      <header>
        <h2>William<br />(Woo Jung)<br />Lee</h2>
      </header>
    </section>

    <section id="footer">
      <ContactIcons />
      <p className="copyright">
        &copy; Woo Jung Lee <Link to="/">wjlee.me</Link>.
      </p>
    </section>
  </section>
);

export default SideBar;
